import { HeroBackground, ProductMain } from '@prishapolicy/shared/ui';

import {
  BasicCard,
  ChoosePlan,
  ChoosePlanProps,
  engineeringfaqList,
  Faq,
  getPurchaseFlowHeroForms,
  HeroTicker,
  ProductCategoryPageProps,
  productsPathAdder,
  ProtectToday,
  useW3PurchaseFlow,
  WhyChooseUs,
} from '@prishapolicy/w3/ui';
import { NextSeo } from 'next-seo';

import Image from 'next/image';
import rightIllustration from './engineering1.png';
import heroImage from './hero-image.png';
const productCategorySlug = 'engineering-insurance';

export function EngineeringInsurance(props: ProductCategoryPageProps) {
  const typeOfInsurances: ChoosePlanProps['cards'] = [
    {
      title: 'EAR Insurance',
      content:
        'Erection All Risk Insurance is a complete engineering insurance that provides coverage for all parties involved in erection work, encompassing operations ',
    },
    {
      title: 'CAR Insurance',
      content:
        'The Contractors Plant and Machinery Policy is a type of machinery insurance that covers movable plant equipment and machinery such as bulldozers, cranes, excavators, and so on.',
    },
    {
      title: 'ALOP Insurance',
      content:
        'For greater financial losses or expenditures incurred as a result of delays in a construction or infrastructure project, the Advanced Loss of Profit Insurance Policy is offered.',
    },
    {
      title: 'CPM Insurance',
      content:
        'The Contractors Plant and Machinery Policy is form of machinery insurance which covers movable plant equipment and machinery such as bulldozers, cranes, excavators, etc.',
    },
    {
      title: 'BPM Insurance',
      content: `The Boiler and Pressure Plant Insurance pays for the upkeep or replacement of the machinery; extended boiler insurance may additionally pay for damage to third parties' property or bodily harm brought.`,
    },
    {
      title: 'EEI Insurance',
      content: `A very beneficial insurance for engineers, this type of insurance provides an all risk Insurance cover in case of breakdowns or damages to electronic devices used in a business.`,
    },
    {
      title: 'MBD Insurance',
      content: `The machinery breakdown insurance covers any physical damage to the machinery resulting from any accidents or unanticipated causes.`,
    },
  ];

  const choosePlanCards: ChoosePlanProps['cards'] = [
    {
      title: 'Understand the scope<br/>of coverages',
      content: (
        <div>
          There are a lot of engineering products and can be difficult to understand the coverages of the different
          insurance products at once. Understanding your own requirements becomes the most important step in this case.
        </div>
      ),
    },
    {
      title: 'Getting insurance for<br/>the correct equipment',
      content: (
        <div>
          Often Engineering products are defined but the type of equipment that are covered in that policy. For example
          Machinery Breakdown Insurance and Electronic Equipment Insurance have a huge overlap with respect to the
          machines covered but there a big that is exclusive to either.
        </div>
      ),
    },
    {
      title: 'Reinstatement vs Depreciation ',
      content: (
        <div>
          Even after choosing the correct engineering insurance for your needs. An important clause can make a lot of
          difference for you and your company when making a claim. A reinstatement condition will cost you more at the
          time of premium but maybe much more beneficial, if you require the same machinery.
        </div>
      ),
    },
  ];
  const { IconRenderer, FormRenderer } = useW3PurchaseFlow(props);
  return (
    <>
      <NextSeo
        title="Engineering Insurance | PrishaPolicy"
        description="From equipment breakdowns to project delays, our engineering insurance provides tailored coverage for your business"
      />
      <ProductMain color="teal">
        <HeroBackground backgroundColor="teal-300" PurchaseFlowFormRenderer={FormRenderer}>
          <div className="grid-cols-2 lg:grid ">
            <div className="flex flex-col justify-between">
              <div>
                <h1 className="heading-1 pb-3">Because your paycheck also need protection.</h1>
                <p className="text-title-6 max-w-[600px]">
                  From equipment breakdowns to project delays, our engineering insurance provides tailored coverage for
                  your business
                </p>
              </div>
              <IconRenderer />
            </div>
            <div className="hidden w-full justify-center lg:flex">
              <div className="mt-10 flex w-3/4 justify-center">
                <Image src={heroImage} alt="contact us" />
              </div>
            </div>
          </div>
        </HeroBackground>
        <HeroTicker />
        <ProtectToday productCategoryPrefix={productCategorySlug} maxPerRow={3} items={props.productPaths} />
        <div className="container py-24">
          <div className=" grid-cols-2 gap-x-24 lg:grid ">
            <div className="flex flex-col justify-center">
              <h3 className="lg:heading-3 heading-4">Engineering Insurance—what is it?</h3>
              <p className="prose mt-4">
                Engineering insurance refers to the insurance that provides economic safeguard to the risks faced by the
                ongoing construction project, installation project, and machines and equipment in project operation.
                <br />
                <br />
                Since this industry is about creating and designing, construction and building, there are increased
                chances of related accidents and perils. Thus, Engineering Insurance policy caters to different forms of
                uncertainties that are associated with on-site construction including plant and machinery usage.
              </p>
            </div>
            <div className="grid place-items-center ">
              <Image src={rightIllustration} alt="engineering insurance" />
            </div>
            <div className="col-span-2 mt-16">
              <h3 className="heading-3">The Necessity of Engineering Insurance </h3>
              <p className="mt-3 max-w-[1100px]">
                Civil engineering is innovation in action, and it is what establishes and guides a nation on the path of
                advancement. However, such massive building projects come with a real risk of losing or damaging the
                equipment and raw materials, or even delaying or harming the actual constructions. To secure everything,
                engineering insurance is used in this situation.
              </p>
            </div>
          </div>
          <div className="mt-8 flex shrink-0 gap-x-3 overflow-x-auto">
            {typeOfInsurances.map((card, index) => {
              return (
                <BasicCard
                  key={index}
                  title={card.title}
                  content={card.content}
                  className="min-w-[85%] lg:min-w-[25%]"
                />
              );
            })}
          </div>
        </div>
        <ChoosePlan cards={choosePlanCards} perRow={3} />
        <WhyChooseUs />
        <Faq list={engineeringfaqList} />
      </ProductMain>
    </>
  );
}

export function getStaticProps() {
  const productPaths = productsPathAdder(productCategorySlug);
  return {
    props: {
      ...getPurchaseFlowHeroForms(productCategorySlug).props,
      productPaths,
    },
  };
}
export default EngineeringInsurance;
